import React from 'react'
import moment from 'moment'
import DatePicker from 'rc-calendar/lib/Picker'
import Calendar from 'rc-calendar'
import injectStyles from 'react-jss'

import { styles } from './styles'
import InputLabel from '@material-ui/core/InputLabel'
import CalendarIcon from './CalendarIcon'

const DatePickerNew = ({
  value,
  onChange,
  classes,
  label,
  description,
  error,
}) => {
  const calendar = <Calendar />

  return (
    <div className={classes.wrap}>
      <InputLabel shrink className={classes.label}>
        {label}
      </InputLabel>
      <span className={classes.pickerWrap}>
        <DatePicker
          animation="slide-up"
          value={value ? moment(value) : value}
          calendar={calendar}
          onChange={onChange}
        >
          {({ value }) => {
            return (
              <input
                className={classes.input}
                value={moment(value).format('MM/DD/YYYY')}
              />
            )
          }}
        </DatePicker>
        <CalendarIcon className={classes.icon} />
      </span>
      {description ? (
        <div className={classes.description}>{description}</div>
      ) : null}
      {error ? (
        <div className={classes.error}>{error}</div>
      ) : (
        <div className={classes.emptyMargin} />
      )}
    </div>
  )
}

export default injectStyles(styles)(DatePickerNew)
